

import { getPageTitle } from '~/assets/js/seo/title.js';

//
import { mapGetters } from 'vuex';
// import { nextTick } from 'vue';
const environment = process.env.NODE_ENV || 'production';
const envSet = require(`~/api/env.${environment}.js`)

//
import {

	//
	doCleanObject,
	doLinkify,

	//
	onInput,
	onAdjustHeight,
	onKeyDown,
	onKeyUp,
	onCompositionStart,
	onCompositionEnd,
	onSubmit,
	onDestroyRenderer,
	onTypeAnimation,

	//
	onSubmitFAQ,

	//
	onBan,
	onUnBan,
	isBanned,
	onCheckBan


} from './utils/chatBotMethods.js';


//
export default {

	data() {
		return {

			model: [
				// { src: '/assets/models/blender/chat/balloon-p-1.glb', scale: 0.85 },
				// { src: '/assets/models/blender/chat/balloon-a-1.glb', scale: 0.85 },
				// { src: '/assets/models/blender/chat/balloon-c-1.glb', scale: 0.85 },
				// { src: '/assets/models/blender/chat/balloon-h-1.glb', scale: 0.85 },
				// { src: '/assets/models/blender/chat/balloon-i-1.glb', scale: 0.85 },
				{ src: '/assets/models/blender/particle/nuts-half.glb', scale: 0.8 },
				{ src: '/assets/models/blender/particle/nuts-half.glb', scale: 0.8 },
				{ src: '/assets/models/blender/particle/nuts-half.glb', scale: 0.8 }
			],

			//
			// mode : 'gpt-3.5-turbo',
			mode : 'gpt-4o',

			//
			isMaxHeightReached : false,
			isChatTalking : false,
			isChatTalkingTimer : false,

			//
			renderer : null,

			//
			setting : [],

			//
			conversation : [],
			output : [],
			inputText: '',
			composing: false,
			compositionTimeout: null,
			height: '1em',
			response: '',
			message: '',

			//
			isWheeling : 0,
			isTouching : 0,

		}
	},

	methods: {

		onTouchMove(){
			this.isTouching = 1;		
		},

		onWheel(){
			this.isWheeling = 1;
		},

		onClickAtag( event ){
			if (event.target.tagName === 'A' && event.target.getAttribute('href').startsWith('/')) {
				event.preventDefault();
				this.$router.push(event.target.getAttribute('href'));
			}
		},
		doCleanObject(obj) {
			return doCleanObject(obj);
		},
		doLinkify(text) {
			return doLinkify(text);
		},
		onInput(e) {
			onInput(this, e);
		},
		onAdjustHeight(textarea, reset = false) {
			onAdjustHeight(this, textarea, reset);
		},
		onKeyDown(e) {
			onKeyDown(e);
		},
		onKeyUp(e) {
			onKeyUp(this, e);
		},
		onCompositionStart() {
			onCompositionStart(this);
		},
		onCompositionEnd() {
			onCompositionEnd(this);
		},

		//=================
		// FAQ
		//=================
		addClassFAQ(item, index) {
			let count = 0;
			for (let i = 0; i < this.chatAi.faq.array.length; i++) {
				if (!this.chatAi.faq.array[i].isUsed) {
					if (count === 3) return false;
					if (index === i) return true;
					count++;
				}
			}
			return false;
		},
		onResetFAQ(){
			this.$store.commit("RESET_FAQ_STATUS");
		},
		onSubmitFAQ(q,a,currentTarget){
			this.isWheeling = 0;
			this.isTouching = 0;
			onSubmitFAQ(this,q,a,currentTarget);
		},

		//=================
		// SUBMIT
		//=================
		onSubmit(e) {
			console.log('onSubmit');
			this.isWheeling = 0;
			this.isTouching = 0;
			onSubmit(this);
		},

		onDestroyRenderer() {
			onDestroyRenderer(this);
		},

		onTypeAnimation(output) {
			onTypeAnimation(this, output);
		},

		//=================
		// BAN
		//=================
		onBan(error){
			onBan(this,error);
		},
		onUnBan(){
			onUnBan(this);
		},
		isBanned(){
			return isBanned();
		},
		onCheckBan() {
			onCheckBan(this);
		}
	},

	beforeDestroy() {
		this.isWheeling = 0;
		this.isTouching = 0;
		$html.classList.remove('is-chat-start');
		this.onDestroyRenderer();
	},

	computed: {
		...mapGetters([
			'chatAi'
		])
	},

	head() {
		let _title = getPageTitle(this.$i18n.locale, 'AI');
		let _description = 'I am Pachi.';
		return {
			title: _title,
			meta: [
				{
					name: 'description',
					content: _description,
				}
			]
		}
	},

	async fetch ({ store, $http }) {
		if( !store.getters.projects.length ){
			const request = `${envSet.staticUrl}/db/projects.json`;
			const response = await $http.$get( request );
			store.dispatch( 'setProjects', response );
		}
	},

	mounted(){

		//
		ROUTE.onMounted( this.$store.$device, {
			current : { type : 'ai', slug : 'ai' },
			prev : null,
			next : null
		});
		this.onAdjustHeight( this.$el.querySelector('textarea'), false ); 

		//
		this.onResetFAQ();
		this.$nextTick(() => {
			if( styleInview ) styleInview.onInit();
		});

	},

	transition : {
		mode: 'out-in',
		css: false,
		beforeEnter( el ){
			ROUTE.beforeEnter( el );
		},
		enter( el, done ){
			ROUTE.enter( el, done );
		},
		afterEnter( el ){
			ROUTE.afterEnter( el );
		},
		leave( el, done ){
			ROUTE.leave(el, done);
		},
	}

}
